import React, { useState } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";

export function ConfirmationDialog({
    visible,
    onHide,
    onConfirm,
    header,
    message,
    confirmLabel = "Confirm",
    confirmIcon = "pi pi-check",
    isDelete = false,
    uid
}: {
    uid?: string, // Optional, depending on context if needed for display or passed back
    visible: boolean;
    onHide: () => void;
    onConfirm: () => Promise<void> | void;
    header: string;
    message: string | React.ReactNode;
    confirmLabel?: string;
    confirmIcon?: string;
    isDelete?: boolean;
}) {
    const [loading, setLoading] = useState<boolean>(false);


    const footer = (
        <div>
            <Button label="Cancel" icon="pi pi-ban" onClick={onHide} className="p-button-text" />
            <Button
                label={confirmLabel}
                icon={confirmIcon}
                onClick={async () => {
                    setLoading(true);
                    try {
                        await onConfirm();
                    } finally {
                        setLoading(false);
                    }
                }}
                loading={loading}
                className={isDelete ? "p-button-danger" : ""}
                autoFocus
            />
        </div>
    );

    return (
        <Dialog
            header={header}
            visible={visible}
            style={{ width: "30rem" }}
            onHide={onHide}
            footer={footer}
        >
            <span className="text-lg">{message}</span>
        </Dialog>
    );
}
